import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

export function SEO({
    title,
    description,
    keywords = 'HVAC, engineering, air conditioning, heating, ventilation, Ahmedabad, Nikket Engineering Works',
    image = '/favicon.svg',
    url,
}) {
    const location = useLocation();
    const siteUrl = 'https://nikketengg.com';
    const siteTitle = 'Nikket Engineering Works | HVAC Experts';
    const fullTitle = `${title} | ${siteTitle}`;
    const canonicalUrl = url ?? `${siteUrl}${location.pathname}`;

    const imageUrl = image.startsWith('http') ? image : `${siteUrl}${image.startsWith('/') ? '' : '/'}${image}`;

    return (
        <Helmet>
            <title>{fullTitle}</title>
            <meta name="description" content={description} />
            <meta name="keywords" content={keywords} />
            <link rel="canonical" href={canonicalUrl} />

            <meta property="og:type" content="website" />
            <meta property="og:url" content={canonicalUrl} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={imageUrl} />
            <meta property="og:site_name" content="Nikket Engineering Works" />

            <meta property="twitter:card" content="summary_large_image" />
            <meta property="twitter:url" content={canonicalUrl} />
            <meta property="twitter:title" content={fullTitle} />
            <meta property="twitter:description" content={description} />
            <meta property="twitter:image" content={imageUrl} />
        </Helmet>
    );
}
